const decisions = {
  decision: 'Решение',
  decisions: 'Решения',
  changedDecision: 'Измененное решение',
  agreed: 'Согласовано',
  notAgreed: 'Не согласовано',
  noDecision: 'Нет решения',
};

export default decisions;
